import { useDispatch } from "react-redux";
import IndividualDetails from "./IndividualDetails";
import RepresentativeDetails from "./RepresentativeDetails";
import TaxPractitionerDetails from "./TaxPractitioner";
import cancelCaptureDetails from "../../../features/CaptureDetailsSlice";
import { CaptureDetailsPrefixConstants, RequestorType } from "../../../models/Enums";

export interface EntityDetailsProps {
  entity: string | undefined;
  representativeType: string | undefined;
}

const EntityDetails = (props: EntityDetailsProps) => {
  const dispatch = useDispatch();

  switch (props.entity) {
    case RequestorType.Individual:
      return <IndividualDetails prefix={CaptureDetailsPrefixConstants.Individual} />;
    case RequestorType.SMMESoleProprietor:
      return <IndividualDetails prefix={CaptureDetailsPrefixConstants.Individual} />;
    case RequestorType.TaxPractitioner:
      return <TaxPractitionerDetails />;
    case RequestorType.Representative:
      return <RepresentativeDetails representativeType={props.representativeType} />;
    default: {
      dispatch(cancelCaptureDetails);
      return null;
    }
  }
};

export default EntityDetails;
